module.exports = __webpack_public_path__ + "assets/374ac6b154b6ab8ba653230e9a42f1c6.svg";